module.exports = __webpack_public_path__ + "static/img/icon_c_google.d81044cb.svg";